import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import _ from "lodash";
import { Form, withFormik, useField } from "formik";
import { colors } from "../../theme/variables";
import { Button, Input } from "../../components";
import {
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  TextField,
  Label,
  InputAdornment,
  IconButton,
  Checkbox,
} from "@material-ui/core";
import * as Icons from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import FormikSwitch from "../../components/formik/FormikSwitch";
import FormikInput from "../../components/formik/FormikInput";
import FormikDropdown from "../../components/formik/FormikDropdown";
import { getCategories } from "../../data/services/API";
import * as Yup from "yup";
import CloseIcon from "@material-ui/icons/Close";
import { TaskType } from "../../utils/constants";

const TIMEOUT_POLICY_OPTIONS = ["Timeout Workflow", "Alert Only"];
const useStyles = makeStyles({
  name: {
    width: "50%",
  },
  description: {
    padding: 0,
    "& .MuiInputBase-root": {
      padding: "5px",
    },
  },
  submitButton: {
    float: "right",
  },
  toolbar: {
    backgroundColor: colors.gray14,
  },
  workflowName: {
    fontWeight: "bold",
  },
  main: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    backgroundColor: "#fff",
  },
  fields: {
    width: "100%",
    padding: 12,
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflowX: "hidden",
    overflowY: "auto",
    gap: 15,
  },
  formLabel: {
    fontSize: "13px",
    fontWeight: 600,
    marginBottom: "0.5rem",
    display: "block",
  },
  iconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "30px",
    height: "20px",
    cursor: "pointer",
  },
  icon: { cursor: "pointer" },
  switchContainer: { marginLeft: 0 },
  switchRoot: { marginRight: "1rem" },
  wfFlafDiv: { marginBottom: "0.5rem" },
  msgTxt: {
    fontSize: "12px",
    textAlign: "justify",
    marginTop: "0.5rem",
  },
  wolkenBtn: {
    padding: "4px 0",
    fontSize: "0.75rem",
    fontFamily: "Poppins, regular",
    lineHeight: "1.5",
  },
});

const convertArrToSeconds = (arr) => {
  var seconds = 0;
  if (arr) {
    arr.forEach((ele, index) => {
      if (!Number.isNaN(ele)) {
        if (index === 3) seconds += Math.floor(ele);
        if (index === 2) seconds += Math.floor(ele * 60);
        if (index === 1) seconds += Math.floor(ele * 3600);
        if (index === 0) seconds += Math.floor(ele * 3600 * 24);
      }
    });
  }
  return seconds;
};

function secondsToDhms(timeSeconds) {
  var days = 0;
  var hours = 0;
  var minutes = 0;
  var seconds = 0;
  if (!Number.isNaN(timeSeconds)) {
    var secondVals = Number(timeSeconds);
    days = Math.floor(secondVals / (3600 * 24));
    hours = Math.floor((secondVals % (3600 * 24)) / 3600);
    minutes = Math.floor((secondVals % 3600) / 60);
    seconds = Math.floor(secondVals % 60);
  }

  let durationVal = [days, hours, minutes, seconds];
  return durationVal;
}

const InputParameter = (props) => {
  const {
    classes,
    deleteInputParam,
    index,
    updateInputParamsValue,
    paramValue,
  } = props;

  const handleChange = (value) => updateInputParamsValue(index, value);

  return (
    <Grid container spacing={2} alignItems="center" justifyContent="center">
      <Grid item xs={11}>
        <Input
          placeholder="e.g.: Cache-Control..."
          fullWidth
          onChange={handleChange}
          value={paramValue}
        />
      </Grid>
      <Grid item xs={1} style={{ alignSelf: "center" }}>
        <div
          className={classes.iconContainer}
          onClick={() => deleteInputParam(index)}
          style={{ color: colors.red07, cursor: "pointer" }}>
          <Icons.DeleteOutlineOutlined />
        </div>
      </Grid>
    </Grid>
  );
};

const OutputParameter = (props) => {
  const {
    classes,
    deleteOutputParam,
    index,
    keyVal,
    updateOutputParamsValue,
    inputParameters,
    outputParameters,
  } = props;

  const [value, setValue] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [inputError, setInputError] = useState(false);

  const handleInputChange = (value) => {
    setInputValue(value);
    if (value && outputParameters.includes(value)) {
      setInputError(true);
    } else {
      setInputError(false);
    }
  };

  const handleValChange = (e, val) => setValue(val || "");

  useEffect(() => {
    if (keyVal) {
      setInputValue(keyVal[0]);
      setValue(keyVal[1]);
    }
  }, [keyVal]);

  useEffect(() => {
    if (value) updateOutputParamsValue(index, keyVal[0], value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    if (inputValue && !outputParameters.includes(inputValue))
      updateOutputParamsValue(index, inputValue, keyVal[1]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue]);

  return (
    <Grid
      container
      spacing={2}
      alignItems="baseline"
      justifyContent="center"
      key={index}
      style={{ paddingTop: "0.5rem" }}>
      <Grid item xs={4}>
        <Input
          placeholder="e.g.: Cache-Control..."
          fullWidth
          label="Parameter"
          value={inputValue}
          onChange={handleInputChange}
          error={!!inputError}
        />
        {!!inputError && (
          <FormControl error={!!inputError}>
            <FormHelperText>Key should be unique</FormHelperText>
          </FormControl>
        )}
      </Grid>
      <Grid item xs={7}>
        <Autocomplete
          disableClearable
          id="output-param-value"
          options={
            inputParameters.length
              ? [
                  // eslint-disable-next-line no-template-curly-in-string
                  "${workflow.input}",
                  ...inputParameters.map((e) => "${workflow.input." + e + "}"),
                ]
              : // eslint-disable-next-line no-template-curly-in-string
                ["${workflow.input}"]
          }
          clearOnBlur={false}
          freeSolo
          value={value}
          inputValue={value}
          onChange={(e, newVal) => handleValChange(e, newVal)}
          onInputChange={(e, newVal) => handleValChange(e, newVal)}
          renderInput={(params) => (
            <TextField
              {...params}
              autoComplete="off"
              label="Value"
              variant="outlined"
              ref={params.InputProps.ref}
              InputProps={{
                ...params.InputParams,
                endAdornment: value && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => {
                        handleValChange(null, "");
                      }}>
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      </Grid>
      <Grid
        item
        xs={1}
        style={{
          alignSelf: "center",
          marginBottom: inputError ? "1rem" : "0px",
        }}>
        <div
          className={classes.iconContainer}
          onClick={() => deleteOutputParam(index)}
          style={{ color: colors.red07, cursor: "pointer" }}>
          <Icons.DeleteOutlineOutlined />
        </div>
      </Grid>
    </Grid>
  );
};

const WorkflowDefinationForm = (props) => {
  const {
    values,
    setFieldValue,
    setDataToBeAddedToJson,
    durationVal,
    touched,
    errors,
    handleChange,
    handleBlur,
  } = props;
  const classes = useStyles();
  const [field, meta, helper] = useField(props);
  const outputParametersFromValues = values.outputParameters;
  const outputParametersKeys =
    values.outputParameters && values.outputParameters.length
      ? values.outputParameters.map((ele) => ele[0])
      : values.outputParameters;
  const [duration, setDuration] = useState(values.ttlSeconds);
  const [workflowDays, setWorkflowDays] = useState(0);
  const [workflowHours, setWorkflowHours] = useState(0);
  const [workflowMins, setWorkflowMins] = useState(0);
  const [workflowSecs, setWorkflowSecs] = useState(0);

  const handleArchiveChange = (e, val) => {

    if(val===true){
      setWorkflowDays(0);
      setWorkflowHours(0);
      setWorkflowMins(0);
      setWorkflowSecs(0);
     
    }
    setFieldValue("archive", val);
  };

  const addInputParamsToArr = () =>
    setFieldValue("inputParameters", [...values.inputParameters, ""]);

  const addOutputParamsToArr = () =>
    setFieldValue("outputParameters", [...values.outputParameters, ["", ""]]);

  const updateInputParamsValue = (index, val) => {
    let temp = [...values.inputParameters];
    temp[index] = val || "";
    setFieldValue("inputParameters", temp);
  };

  const updateOutputParamsValue = (index, param, val) => {
    let temp = [...values.outputParameters];
    temp[index][0] = param || "";
    temp[index][1] = val || "";
    setFieldValue("outputParameters", temp);
  };

  const deleteInputParam = (index) => {
    let temp = [...values.inputParameters];
    temp = temp.filter((e, idx) => idx !== index);
    setFieldValue("inputParameters", temp);
  };

  const deleteOutputParam = (index) => {
    let temp = [...values.outputParameters];
    temp = temp.filter((e, idx) => idx !== index);
    setFieldValue("outputParameters", temp);
  };

  const updateTtlSeconds = (durationVal) => {
    setFieldValue("ttlSeconds", durationVal);
  };

  useEffect(() => {
    let time = [];

    if (values.ttlSeconds) {
      time = secondsToDhms(values.ttlSeconds);
      // updateTtlSeconds(duration);
      setWorkflowDays(time[0]);
      setWorkflowHours(time[1]);
      setWorkflowMins(time[2]);
      setWorkflowSecs(time[3]);

      props.setWorkflowDays(Math.floor(time[0] * 3600 * 24));
      props.setWorkflowHours(Math.floor(time[1] * 3600));
      props.setWorkflowMinutes(Math.floor(time[2] * 60));
      props.setWorkflowSeconds(Math.floor(time[3]));
      props.setDuration(values.ttlSeconds);
    }
  }, [values.ttlSeconds]);

  useEffect(() => {
    setDuration(workflowDays + workflowHours + workflowMins + workflowSecs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workflowDays, workflowHours, workflowMins, workflowSecs]);

  useEffect(() => {
    setDataToBeAddedToJson({
      ...values,
      outputParameters:
        values.outputParameters && values.outputParameters.length
          ? Object.fromEntries(values.outputParameters)
          : {},
    });

    return () => {};
  }, [setDataToBeAddedToJson, values]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCategories();
        setCategories(response.data);
      } catch (error) {}
    };

    fetchData();
  }, []);

  // const handleDurationChange = (e, str, index) => {
  //   e.persist();

  //   setDuration((prevState) => {
  //     let temp = [];
  //     if (prevState !== undefined && prevState !== null && prevState != "") {
  //       temp = [...prevState];
  //     }
  //     if (!Number.isNaN(e.target.value)) {
  //       temp[index] = Number(e.target.value);
  //     }
  //     setTimeout(() => {
  //       updateTtlSeconds(temp);
  //     }, 400);

  //     return temp;
  //   });
  // };
  const handleDaysChange = (event) => {
    const { value } = event.target;
    // field.onChange(event);
    setWorkflowDays(value);
    props.handleDaysChange(value); // Pass the value to the parent function
  };

  const handleHoursChange = (event) => {
    const { value } = event.target;
    // field.onChange(event);
    setWorkflowHours(value);
    props.handleHoursChange(value); // Pass the value to the parent function
  };

  const handleMinutesChange = (event) => {
    const { value } = event.target;
    // field.onChange(event);
    setWorkflowMins(value);
    props.handleMinutesChange(value); // Pass the value to the parent function
  };

  const handleSecondsChange = (event) => {
    const { value } = event.target;
    // field.onChange(event);
    setWorkflowSecs(value);
    props.handleSecondsChange(value); // Pass the value to the parent function
  };

  const renderCategoryField = () => {
    if (categories.length <= 1) {
      if (categories.length === 1) {
        props.workflowDef.category = categories[0];
      }
      return null; // Don't render the category field
    }

    return (
      <Grid item xs={12}>
        <FormikDropdown
          id="category"
          label="Type"
          name="category"
          variant="outlined"
          fullWidth
          freeSolo
          options={categories.map((obj) => obj)}
          required={true}
          // options={categories.map((obj) => obj.categoryName)}
          taskReferenceName={"category"}
        />
      </Grid>
    );
  };

  return (
    <Form className={classes.main}>
      <div className={classes.fields}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="flex-start">
          <Grid item xs={12}>
            <FormikInput
              id="name"
              label="Workflow Name"
              name="workflowName"
              variant="outlined"
              fullWidth
              required
              taskReferenceName={"workflowName"}
            />
          </Grid>
          {renderCategoryField()}

          <Grid item xs={12}>
            <FormikInput
              id="description"
              label="Description"
              name="description"
              className={classes.description}
              multiline
              minRows={2}
              maxRows={4}
              variant="outlined"
              fullWidth
              taskReferenceName={"description"}
            />
          </Grid>
        </Grid>

        <div className="">
          <label className={classes.formLabel}>Input Parameters</label>
          {values.inputParameters && values.inputParameters.length
            ? values.inputParameters.map((ele, index) => (
                <InputParameter
                  key={index}
                  classes={classes}
                  index={index}
                  deleteInputParam={deleteInputParam}
                  updateInputParamsValue={updateInputParamsValue}
                  paramValue={ele}
                />
              ))
            : ""}
          <Button className={classes.wolkenBtn} onClick={addInputParamsToArr}>
            <Icons.Add /> Add
          </Button>
        </div>

        <div className="">
          <label className={classes.formLabel}>Output Parameters</label>
          {outputParametersFromValues && outputParametersFromValues.length
            ? outputParametersFromValues.map((keyVal, index) => (
                <OutputParameter
                  key={index}
                  classes={classes}
                  deleteOutputParam={deleteOutputParam}
                  updateOutputParamsValue={updateOutputParamsValue}
                  inputParameters={values.inputParameters}
                  keyVal={keyVal}
                  outputParameters={outputParametersKeys}
                  index={index}
                />
              ))
            : ""}
          <Button className={classes.wolkenBtn} onClick={addOutputParamsToArr}>
            <Icons.Add /> Add
          </Button>
        </div>

        <div className={classes.wfFlafDiv}>
          <label className={classes.formLabel}>Workflow Flags</label>
          <FormGroup>
            <FormControlLabel
              control={
                <FormikSwitch
                  color="primary"
                  className={classes.switchRoot}
                  name="restartable"
                  taskReferenceName={"restartable"}
                />
              }
              label="Restartable"
              className={classes.switchContainer}
            />
          </FormGroup>

          <div className={classes.msgTxt}>
            If restarting a completed workflow can have side effects, turn this
            flag off and completed workflows will not be allowed to restart.
          </div>
        </div>

        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="flex-start">
          <Grid item xs={6}>
            <FormikInput
              id="timeout-seconds"
              label="Timeout Seconds"
              name="timeoutSeconds"
              type="number"
              variant="outlined"
              fullWidth
              taskReferenceName={"timeoutSeconds"}
            />
          </Grid>
          <Grid item xs={6}>
            <FormikDropdown
              id="timeout-policy"
              label="Timeout Policy"
              name="timeoutPolicy"
              variant="outlined"
              fullWidth
              freeSolo
              options={TIMEOUT_POLICY_OPTIONS}
              taskReferenceName={"timeout-policy"}
            />
          </Grid>
          <Grid item xs={12}>
            <FormikDropdown
              id="faliure-name"
              label="Failure Workflow Name"
              name="failureWorkflow"
              placeholder="e.g.: max-age=..."
              variant="outlined"
              fullWidth
              freeSolo
              options={[]}
              taskReferenceName={"faliure-name"}
            />
            <div className={classes.msgTxt}>
              If present, this workflow will be triggered upon a failure of the
              execution of this workflow.
            </div>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={values.archive}
                color="primary"
                onChange={handleArchiveChange}
              />
            }
            label="Archive"
          />
        </Grid>

        {!values.archive && <>
        <div className="">
          <label className={classes.formLabel}>Time To Live</label>
        </div>
        <Grid
          container
          spacing={2}
          alignItems="center"
          marginTop={10}
          justifyContent="flex-start">
          <Grid item xs={3}>
            <FormikInput
              id="workflowDays"
              label="Days"
              name="workflowDays"
              type="number"
              variant="outlined"
              fullWidth
              value={workflowDays}
              onChange={handleDaysChange}
              
              error={meta.touched && workflowDays < 0}
            />
            <div style={{ minHeight: "24px" }}>
              {meta.touched && workflowDays < 0 && (
                <FormControl error={!!meta.touched && workflowDays < 0}>
                  <FormHelperText>Days must be 0 or more</FormHelperText>
                </FormControl>
              )}
            </div>
          </Grid>

          <Grid item xs={3}>
            <FormikInput
              id="workflowHours"
              label="Hours"
              name="workflowHours"
              type="number"
              variant="outlined"
              fullWidth
              value={workflowHours}
              onChange={handleHoursChange}
              
              error={meta.touched && (workflowHours < 0 || workflowHours > 23)}
            />
            <div style={{ minHeight: "24px" }}>
              {meta.touched && workflowHours < 0 ? (
                <FormControl error={!!meta.touched && workflowHours < 0}>
                  <FormHelperText>Hours must be 0 or more</FormHelperText>
                </FormControl>
              ) : (
                meta.touched &&
                workflowHours > 23 && (
                  <FormControl error={!!meta.touched && workflowHours > 23}>
                    <FormHelperText>Hours must be less than 24</FormHelperText>
                  </FormControl>
                )
              )}
            </div>
          </Grid>

          <Grid item xs={3}>
            <FormikInput
              id="workflowMins"
              label="Minutes"
              name="workflowMins"
              type="number"
              variant="outlined"
              fullWidth
              value={workflowMins}
              onChange={handleMinutesChange}
              
              error={meta.touched && (workflowMins < 0 || workflowMins > 59)}
            />
            <div style={{ minHeight: "24px" }}>
              {meta.touched && workflowMins < 0 ? (
                <FormControl error={!!meta.touched && workflowMins < 0}>
                  <FormHelperText>Mins must be 0 or more</FormHelperText>
                </FormControl>
              ) : (
                meta.touched &&
                workflowMins > 59 && (
                  <FormControl error={!!meta.touched && workflowMins > 59}>
                    <FormHelperText>Mins must be less than 60</FormHelperText>
                  </FormControl>
                )
              )}
            </div>
          </Grid>

          <Grid item xs={3}>
            <FormikInput
              id="workflowSecs"
              label="Seconds"
              name="workflowSecs"
              type="number"
              variant="outlined"
              fullWidth
              value={workflowSecs}
              onChange={handleSecondsChange}
              handleBlur={handleBlur}
              
              error={meta.touched && (workflowSecs < 0 || workflowSecs > 59)}
            />
            <div style={{ minHeight: "24px" }}>
              {meta.touched && workflowSecs < 0 ? (
                <FormControl error={meta.touched && workflowSecs < 0}>
                  <FormHelperText>Secs must be 0 or more</FormHelperText>
                </FormControl>
              ) : (
                meta.touched &&
                workflowSecs > 59 && (
                  <FormControl error={meta.touched && workflowSecs > 59}>
                    <FormHelperText>Secs must be less than 60</FormHelperText>
                  </FormControl>
                )
              )}
            </div>
          </Grid>
        </Grid>
        </>
}
      </div>
      {/* </div> */}
    </Form>
  );
};

function workflowDefPayloadToFormData(workflowDefPayload, workflowDef) {
  let timeoutPol = [];

  let opParam = workflowDef?.outputParameters
    ? Object.entries(workflowDef?.outputParameters)
    : [];
  if (_.get(workflowDef, "timeoutPolicy", "")) {
    _.get(workflowDef, "timeoutPolicy", "")
      .split("_")
      .forEach((ele) => timeoutPol.push(_.capitalize(ele)));
  }

  if (_.get(workflowDef, "ttlSeconds", "")) {
    let secs = _.get(workflowDef, "ttlSeconds", "");
    if (secs) {
      let durationValues = secondsToDhms(secs);
    }
  }

  return {
    name:
      _.get(workflowDefPayload, "name", "") ||
      _.get(workflowDef, "name", "") ||
      null,
    workflowName:
      _.get(workflowDefPayload, "workflowName", "") ||
      _.get(workflowDef, "workflowName", ""),
    description:
      _.get(workflowDefPayload, "description", "") ||
      _.get(workflowDef, "description", ""),
    category:
      _.get(workflowDefPayload, "category", "") ||
      _.get(workflowDef, "category", ""),
    version:
      _.get(workflowDefPayload, "version", 1) ||
      _.get(workflowDef, "version", 1),
    inputParameters:
      _.get(workflowDefPayload, "inputParameters") ||
      _.get(workflowDef, "inputParameters"),
    outputParameters: _.get(workflowDefPayload, "outputParameters") || opParam,
    restartable:
      _.get(workflowDefPayload, "restartable", false) ||
      _.get(workflowDef, "restartable", false),
    timeoutSeconds:
      _.get(workflowDefPayload, "timeoutSeconds", "") ||
      _.get(workflowDef, "timeoutSeconds", ""),
    timeoutPolicy:
      _.get(workflowDefPayload, "timeoutPolicy", "") || timeoutPol.join(" "),
    failureWorkflow: _.get(workflowDefPayload, "failureWorkflow", ""),
    ttlSeconds:
      _.get(workflowDefPayload, "ttlSeconds", "") ||
      _.get(workflowDef, "ttlSeconds", ""),
    archive:
      _.get(workflowDefPayload, "archive", false) ||
      _.get(workflowDef, "archive", false),
  };
}

export default withFormik({
  enableReinitialize: true,
  mapPropsToValues: (props) =>
    workflowDefPayloadToFormData(
      _.get(props, "workflowDefPayload"),
      _.get(props, "workflowDef")
    ),
  validationSchema: Yup.object().shape({
    workflowName: Yup.string()
      .max(50, "Name must be at most 50 characters")
      .matches(/^[a-zA-Z0-9._ ]+$/, "Name cannot contain special characters")
      // .matches(/^[a-zA-Z\s]+$/, "Name cannot contain special characters")
      .required("Name is required")
      .nullable(),
    category: Yup.string().required("Category is required").nullable(),
    workflowDays: Yup.number().min(0, "Days must be 0 or more"),
    workflowHours: Yup.number()
      .min(0, "Hours must be 0 or more")
      .max(23, "Hours must be less than 24"),
    workflowMins: Yup.number()
      .min(0, "Minutes must be 0 or more")
      .max(59, "Minutes must be less than 60"),
    workflowSecs: Yup.number()
      .min(0, "Seconds must be 0 or more")
      .max(59, "Seconds must be less than 60"),

    // Add other validation rules for other fields if needed
  }),
})(WorkflowDefinationForm);
